import CompanyOneOffExtraInfoTemplate from "./template";

export default CompanyOneOffExtraInfoTemplate